import { render, staticRenderFns } from "./PhotographyServices.vue?vue&type=template&id=fb21c9a8&scoped=true&"
import script from "./PhotographyServices.vue?vue&type=script&lang=js&"
export * from "./PhotographyServices.vue?vue&type=script&lang=js&"
import style0 from "./PhotographyServices.vue?vue&type=style&index=0&id=fb21c9a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb21c9a8",
  null
  
)

export default component.exports